export const phoneStyles: {
  width: number;
  height: number;
  header: number;
  footer: number;
  body: number;
  keypadHeight: number;
  ivrHeight: number;
  draggableHeaderHeight: number;
  incomingMinHeight: number;
  inCallMinHeight: number;
  rejectMessageHeight: number;
} = Object();
phoneStyles.width = 332;
phoneStyles.height = 590;
phoneStyles.header = 62;
phoneStyles.footer = 60;
phoneStyles.body = phoneStyles.height - (phoneStyles.header + phoneStyles.footer);
phoneStyles.keypadHeight = 348;
phoneStyles.ivrHeight = 320;
phoneStyles.draggableHeaderHeight = 40;
phoneStyles.incomingMinHeight = 134;
phoneStyles.inCallMinHeight = 144;
phoneStyles.rejectMessageHeight = 44;

export const phoneModes = {
  dialer: 'dialer',
  incoming: 'incoming',
  inCall: 'in-call',
  transferCall: 'transfer-call',
} as const;
